import { connect } from 'react-redux'

import Component from './Component'

import componentWillMount from './Handlers/componentWillMount'
import onClickRecord from './Handlers/onClickRecord'
import onClickActionMenuItem from './Handlers/onClickActionMenuItem'

const mapStateToProps = (state) => ({
  fetching: state.screens.ProjectView.fetching,
})

const actionCreators = {
  componentWillMount,
  onClickRecord,
  onClickActionMenuItem,
}

export default connect(mapStateToProps, actionCreators)(Component)
